import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss']
})
export class VerifyEmailComponent implements OnInit {

  constructor(private http: HttpClient,
    private route: ActivatedRoute,
    private router:Router) { }

  ngOnInit(): void {
    const queryURL = this.route.snapshot.queryParamMap.get('queryURL');
    if (queryURL != null) {
      this.http.get(queryURL).toPromise().then((res)=>{
        this.router.navigate(['main'])
      })
      .catch((error)=>{
        console.log(error)
      })
    }
  }
  

}
